_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[37],{

/***/ "Dtc0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "__N_SSG", function() { return /* binding */ __N_SSG; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__("MX0m");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/components/Learn/Container/index.jsx + 20 modules
var Container = __webpack_require__("MR80");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var index_esm = __webpack_require__("v7au");

// EXTERNAL MODULE: ./src/components/Padder/index.jsx
var Padder = __webpack_require__("gH8l");

// EXTERNAL MODULE: ./src/utils/styles.js
var styles = __webpack_require__("oCA+");

// CONCATENATED MODULE: ./src/constants/styles.js

var cellGrow = [".cell-grow{-moz-osx-font-smoothing:grayscale;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);-webkit-transition:-webkit-transform 0.25s ease-out;-webkit-transition:transform 0.25s ease-out;transition:transform 0.25s ease-out;}", ".cell-grow:hover,.cell-grow:focus{-webkit-transform:scale(1.0075);-ms-transform:scale(1.0075);transform:scale(1.0075);}", ".cell-grow:active{-webkit-transform:scale(0.99);-ms-transform:scale(0.99);transform:scale(0.99);}"];
cellGrow.__hash = "1514576463";
var paymentStyles = [".result-message.jsx-1470479211{line-height:22px;font-size:16px;}", ".result-message.jsx-1470479211 a.jsx-1470479211{color:rgb(89,111,214);font-weight:600;-webkit-text-decoration:none;text-decoration:none;}", ".hidden.jsx-1470479211{display:none;}", "#card-error.jsx-1470479211{color:rgb(105,115,134);font-size:16px;line-height:20px;margin-top:12px;text-align:center;}", "#card-element.jsx-1470479211{border-radius:4px 4px 0 0;padding:12px;border:1px solid rgba(50,50,93,0.1);max-height:44px;width:100%;background:white;box-sizing:border-box;}", "#payment-request-button.jsx-1470479211{margin-bottom:32px;}", "button.jsx-1470479211{background:".concat(styles["a" /* COLORS */].blue, ";color:").concat(styles["a" /* COLORS */].white, ";border-radius:0 0 4px 4px;border:0;padding:12px 16px;font-size:16px;font-weight:600;cursor:pointer;display:block;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;box-shadow:0px 4px 5.5px 0px rgba(0,0,0,0.07);width:100%;}"), "button.jsx-1470479211:hover{-webkit-filter:contrast(115%);filter:contrast(115%);}", "button.jsx-1470479211:disabled{opacity:0.5;cursor:default;}", ".spinner.jsx-1470479211,.spinner.jsx-1470479211:before,.spinner.jsx-1470479211:after{border-radius:50%;}", ".spinner.jsx-1470479211{color:".concat(styles["a" /* COLORS */].white, ";font-size:22px;text-indent:-99999px;margin:0px auto;position:relative;width:20px;height:20px;box-shadow:inset 0 0 0 2px;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);}"), ".spinner.jsx-1470479211:before,.spinner.jsx-1470479211:after{position:absolute;content:\"\";}", ".spinner.jsx-1470479211:before{width:10.4px;height:20.4px;background:".concat(styles["a" /* COLORS */].blue, ";border-radius:20.4px 0 0 20.4px;top:-0.2px;left:-0.2px;-webkit-transform-origin:10.4px 10.2px;-webkit-transform-origin:10.4px 10.2px;-ms-transform-origin:10.4px 10.2px;transform-origin:10.4px 10.2px;-webkit-animation:loading 2s infinite ease 1.5s;-webkit-animation:loading-jsx-1470479211 2s infinite ease 1.5s;animation:loading-jsx-1470479211 2s infinite ease 1.5s;}"), ".spinner.jsx-1470479211:after{width:10.4px;height:10.2px;background:".concat(styles["a" /* COLORS */].blue, ";border-radius:0 10.2px 10.2px 0;top:-0.1px;left:10.2px;-webkit-transform-origin:0px 10.2px;-webkit-transform-origin:0px 10.2px;-ms-transform-origin:0px 10.2px;transform-origin:0px 10.2px;-webkit-animation:loading 2s infinite ease;-webkit-animation:loading-jsx-1470479211 2s infinite ease;animation:loading-jsx-1470479211 2s infinite ease;}"), "@-webkit-keyframes loading-jsx-1470479211{0%{-webkit-transform:rotate(0deg);-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);transform:rotate(360deg);}}", "@keyframes loading-jsx-1470479211{0%{-webkit-transform:rotate(0deg);-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);transform:rotate(360deg);}}", "@media only screen and (max-width:600px){form.jsx-1470479211{width:80vw;}}"];
paymentStyles.__hash = "1470479211";
// CONCATENATED MODULE: ./src/components/Landing/HeroSection/styles.js
var styles_styles = ["@media (max-width:30em){.hero__brand--priceblocs.jsx-1154698389{height:3rem;}}", "@media (min-width:30em) and (max-width:60em){.hero__brand--priceblocs.jsx-1154698389{height:3rem;}}", "@media (min-width:60em){.hero__brand--priceblocs.jsx-1154698389{height:4rem;}}", ".hero__logo.jsx-1154698389{background-image:url(\"/learn/assets/hero__logo.png\");}", ".bg__hero.jsx-1154698389::before{content:\"\";position:absolute;top:0;left:0;right:0;width:100%;pointer-events:none;height:100%;background-color:transparent;background-repeat:no-repeat;z-index:-1;}", "@media (max-width:30em){.bg__hero.jsx-1154698389::before{background-position:top;background-size:contain;}}", "@media (min-width:30em) and (max-width:60em){.bg__hero.jsx-1154698389::before{background-position:right;background-size:contain;background-image:url(\"/learn/assets/bg__hero--desktop.svg\");}}", "@media (min-width:60em){.bg__hero.jsx-1154698389::before{background-position:right;background-size:contain;background-image:url(\"/learn/assets/bg__hero--desktop.svg\");}}"];
styles_styles.__hash = "1154698389";
// CONCATENATED MODULE: ./src/pages/index.jsx


var __jsx = react_default.a.createElement;








var DOCS_GRID_CONFIG = [{
  id: "intro",
  Icon: index_esm["f" /* RiDoorOpenLine */],
  label: "Intro",
  description: "What PriceBlocs is and how it can help you sell online.",
  link: {
    as: "/introduction/overview",
    href: "/introduction/overview"
  }
}, {
  id: "account",
  Icon: index_esm["b" /* RiBankLine */],
  label: "Account",
  description: "How individuals and teams can authenticate and signup to PriceBlocs.",
  link: {
    as: "/account/overview",
    href: "/account/[slug]"
  }
}, {
  id: "merchant-account",
  Icon: index_esm["b" /* RiBankLine */],
  label: "Merchant Account",
  description: "How to connect a merchant account and how to get paid.",
  link: {
    as: "/merchant-account/overview",
    href: "/merchant-account/[slug]"
  }
}, {
  id: "resources",
  Icon: index_esm["c" /* RiBubbleChartLine */],
  label: "Resources",
  description: "Learn more about all of your key payment resources which can be used in your payment links.",
  link: {
    as: "/resources/overview",
    href: "/resources/[slug]"
  }
}, {
  id: "links",
  Icon: index_esm["g" /* RiLinksFill */],
  label: "Payment Links",
  description: "How to build and configure your payment links.",
  link: {
    as: "/payment-links/overview",
    href: "/payment-links/[slug]"
  }
}, {
  id: "pages",
  Icon: index_esm["i" /* RiStickyNoteLine */],
  label: "Payment Pages",
  description: "How to build and configure your payment pages.",
  link: {
    as: "/payment-pages/overview",
    href: "/payment-pages/[slug]"
  }
}, {
  id: "checkout",
  label: "Checkout",
  Icon: index_esm["a" /* RiBankCardLine */],
  description: "What the secure checkout is and how to use it.",
  link: {
    as: "/checkout/overview",
    href: "/checkout/[slug]"
  }
}, {
  id: "content",
  label: "Content",
  Icon: index_esm["j" /* RiUploadCloud2Line */],
  description: "How to attach your digital content for sale with payment links.",
  link: {
    as: "/content/overview",
    href: "/content/[slug]"
  }
}, {
  id: "sales",
  Icon: index_esm["h" /* RiMoneyDollarBoxLine */],
  label: "Sales",
  description: "Managing your sales and how to configure payouts.",
  link: {
    as: "/sales/overview",
    href: "/sales/[slug]"
  }
}, {
  id: "customers",
  Icon: index_esm["d" /* RiCustomerService2Line */],
  label: "Customers",
  description: "Managing your Customers and their billing.",
  link: {
    as: "/customers/overview",
    href: "/customers/[slug]"
  }
}, {
  id: "billing",
  Icon: index_esm["k" /* RiWalletLine */],
  label: "Billing",
  description: "Everything related to PriceBlocs' premium features and managing your account billing.",
  link: {
    as: "/billing/overview",
    href: "/billing/[slug]"
  }
}];

var pages_Docs = function Docs(_ref) {
  var navConfig = _ref.navConfig;
  return __jsx(Container["a" /* default */], {
    navConfig: navConfig
  }, __jsx("div", {
    className: "jsx-2019882699 " + "jsx-".concat(cellGrow.__hash, " jsx-").concat(styles_styles.__hash) + " " + "w-100 overflow-y-scroll-l"
  }, __jsx("div", {
    className: "jsx-2019882699 " + "jsx-".concat(cellGrow.__hash, " jsx-").concat(styles_styles.__hash) + " " + "w-100 pv4 pv5-l mw8 w-100 center"
  }, __jsx("div", {
    className: "jsx-2019882699 " + "jsx-".concat(cellGrow.__hash, " jsx-").concat(styles_styles.__hash) + " " + "dib hero__brand--priceblocs w-100 z-1"
  }, __jsx("div", {
    className: "jsx-2019882699 " + "jsx-".concat(cellGrow.__hash, " jsx-").concat(styles_styles.__hash) + " " + "hero__logo contain bg-left h-100 w-100"
  })), __jsx("div", {
    className: "jsx-2019882699 " + "jsx-".concat(cellGrow.__hash, " jsx-").concat(styles_styles.__hash) + " " + "pt3 pt4-l pb4"
  }, __jsx("h1", {
    className: "jsx-2019882699 " + "jsx-".concat(cellGrow.__hash, " jsx-").concat(styles_styles.__hash) + " " + "fw6 f3 f2-l pa0 ma0 pb3 pt2"
  }, "Learn"), __jsx("h3", {
    className: "jsx-2019882699 " + "jsx-".concat(cellGrow.__hash, " jsx-").concat(styles_styles.__hash) + " " + "f5 f4-l pt0 fw5 ma0 pa0 lh-copy"
  }, "Learn more about how to use PriceBlocs to sell your products in any channel.")), __jsx("div", {
    className: "jsx-2019882699 " + "jsx-".concat(cellGrow.__hash, " jsx-").concat(styles_styles.__hash) + " " + "grid-container"
  }, DOCS_GRID_CONFIG.map(function (_ref2, gridIx) {
    var id = _ref2.id,
        label = _ref2.label,
        description = _ref2.description,
        Icon = _ref2.Icon,
        link = _ref2.link,
        callout = _ref2.callout,
        disabled = _ref2.disabled;
    return __jsx(link_default.a, Object(esm_extends["a" /* default */])({}, link, {
      key: gridIx
    }), __jsx("div", {
      className: "jsx-2019882699 " + "jsx-".concat(cellGrow.__hash, " jsx-").concat(styles_styles.__hash) + " " + (classnames_default()("".concat(id, " flex flex-column w-100 ba br2 hairline-1 pa3 mb3 mb-ns relative"), {
        "pointer cell-grow bg-white--hover ba--primary--hover": !disabled,
        "o-90 cursor-not-allowed": disabled
      }) || "")
    }, __jsx("div", {
      className: "jsx-2019882699 " + "jsx-".concat(cellGrow.__hash, " jsx-").concat(styles_styles.__hash) + " " + "flex flex-row items-center"
    }, __jsx(Icon, {
      size: 20,
      className: "jsx-2019882699 " + "jsx-".concat(cellGrow.__hash, " jsx-").concat(styles_styles.__hash)
    }), __jsx("div", {
      style: {
        marginTop: 2
      },
      className: "jsx-2019882699 " + "jsx-".concat(cellGrow.__hash, " jsx-").concat(styles_styles.__hash) + " " + "f4 fw6 pl2 color-primary lh-title"
    }, label)), __jsx("div", {
      className: "jsx-2019882699 " + "jsx-".concat(cellGrow.__hash, " jsx-").concat(styles_styles.__hash) + " " + "f6 lh-copy pt2 mt1"
    }, description)));
  }))), __jsx(Padder["a" /* default */], {
    theme: "visible"
  }), __jsx(style_default.a, {
    id: "2019882699"
  }, ["@media (max-width:30em){.grid-container.jsx-2019882699{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}}", "@media (min-width:30em){.grid-container.jsx-2019882699{display:grid;grid-template-columns:repeat(3,1fr);grid-template-rows:repeat(4,1fr);gap:8px 8px;grid-template-areas: \"intro account merchant-account\" \"resources links checkout\" \"content sales customers\" \"billing . .\";}}", ".intro.jsx-2019882699{grid-area:intro;}", ".account.jsx-2019882699{grid-area:account;}", ".merchant-account.jsx-2019882699{grid-area:merchant-account;}", ".resources.jsx-2019882699{grid-area:resources;}", ".checkout.jsx-2019882699{grid-area:checkout;}", ".links.jsx-2019882699{grid-area:links;}", ".content.jsx-2019882699{grid-area:content;}", ".sales.jsx-2019882699{grid-area:sales;}", ".customers.jsx-2019882699{grid-area:customers;}", ".billing.jsx-2019882699{grid-area:billing;}"]), __jsx(style_default.a, {
    id: cellGrow.__hash
  }, cellGrow), __jsx(style_default.a, {
    id: styles_styles.__hash
  }, styles_styles)));
};

var __N_SSG = true;
/* harmony default export */ var pages = __webpack_exports__["default"] = (pages_Docs);

/***/ }),

/***/ "H0SL":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__("Dtc0");
      }
    ]);
  

/***/ })

},[["H0SL",1,2,3,4,5,7,8,11,10,12,0,6,9]]]);